import { Text, TextType } from 'ui-components/components/text';

import { orders } from './constants';
import GroupByItem from './group-by-item';
import { GroupByOrderNumber } from './group-by-order-number';
import style from './items-section-content.module.less';
import messages from './messages';

/**
 * @typedef {import('./items-section-types.d.ts').GroupByOption} GroupByOption
 */

/**
 * @param {object} props
 * @param {string[]} props.fulfillmentPlanIds
 * @param {(productId: string) => void} props.openProductDetailModal
 * @param {number} props.totalCount
 * @param {GroupByOption} props.userSettingGroupItemsBy
 * @param {boolean} props.willInventoryShow
 * @returns {JSX.Element}
 */
export const ItemsSectionContent = ({
  fulfillmentPlanIds,
  openProductDetailModal,
  totalCount,
  userSettingGroupItemsBy,
  willInventoryShow,
}) => {
  const GroupByComponent = userSettingGroupItemsBy === orders ? GroupByOrderNumber : GroupByItem;

  return (
    <div className={style['items-section-content']}>
      {totalCount ? (
        <GroupByComponent
          fulfillmentPlanIds={fulfillmentPlanIds}
          itemsListContainerClassName={style['items-list-container']}
          openProductDetailModal={openProductDetailModal}
          willInventoryShow={willInventoryShow}
        />
      ) : (
        <Text className={style['no-items-message']} textType={TextType.Paragraph} value={messages.noItems} />
      )}
    </div>
  );
};
